module.exports = __webpack_public_path__ + "img/video_player.e5267917.png";